import settings from 'src/settings';

export const SEARCH_FORM_SETTINGS = {
  DEBOUNCE_TIME: 300,
  MINIMUM_CHARACTERS: 2,
  SHAPING_THRESHOLD: 10,
};
Object.freeze(SEARCH_FORM_SETTINGS);

export const API_RESULT_LIMITS = {
  DEFAULT: 10,
  SEARCH: settings.VITE_APP_API_RESULT_LIMITS_SEARCH,
};
Object.freeze(API_RESULT_LIMITS);

export const USER_ADMIN_PAGE_SIZE =
  import.meta.env.NODE_ENV === 'production' ? 100 : 10;

// Used to give the layers of our application a specific
// z-index range to work with.
export const Z_INDEX_LAYERS = {
  BACKGROUND: {
    BASE: 0,
  },
  MODULE: {
    BASE: 100,
  },
  FRONT: {
    BASE: 200,
  },
};

export enum LOGIN_SSO_PROVIDER {
  AZURE = 'azure',
  GOOGLE = 'google',
}
